<div class="chart-container">
  <canvas
    *ngIf="chartOptions$ | async"
    baseChart
    [datasets]="data"
    [labels]="chartLabels$ | async"
    [options]="chartOptions$ | async"
    [plugins]="plugins"
    [legend]="legend"
    [type]="'bar'">
  </canvas>
</div>
